export const SalesChannelsBoxOffice = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 14V26H13" stroke="currentColor" stroke-width="2"/>
<path d="M5 14L5 27" stroke="currentColor" stroke-width="2"/>
<path d="M9 9V14" stroke="currentColor" stroke-width="2"/>
<path d="M16 9V14" stroke="currentColor" stroke-width="2"/>
<path d="M23 9V14" stroke="currentColor" stroke-width="2"/>
<path d="M4.72076 4L27.2792 4L29 9.16228V14H3L3 9.16228L4.72076 4Z" stroke="currentColor" stroke-width="2"/>
<path d="M29 25.9494V28H16V25.9494L16.142 25.9166C17.0345 25.7106 17.6667 24.9159 17.6667 24C17.6667 23.0841 17.0345 22.2894 16.142 22.0834L16 22.0506L16 20H29V22.0506L28.858 22.0834C27.9655 22.2894 27.3333 23.0841 27.3333 24C27.3333 24.9159 27.9655 25.7106 28.858 25.9166L29 25.9494Z" stroke="currentColor" stroke-width="2"/>
<path d="M23.75 19L23.75 21.3077" stroke="currentColor" stroke-width="2"/>
<path d="M23.75 22.0769V25.1538" stroke="currentColor" stroke-width="2"/>
<path d="M23.75 25.9231V29" stroke="currentColor" stroke-width="2"/>
<path d="M27 13V18" stroke="currentColor" stroke-width="2"/>
</svg>`;
